module.exports = __webpack_public_path__ + "static/media/Bot1.d48deeea.png";